import React, { useEffect, useState, useRef } from 'react'
import * as S from './styles'

import { useWindowSize } from '@/contexts/WindowSizeContext'
import ContentMenu from './ContentMenu'
import ContentItem from './ContentItem'
import Decoration from '@/components/LandingPage/Decoration'
import { isValueDefined } from '@/services/functions'
import { useTranslation } from 'react-i18next'

const ContentSection = ({ data, index }) => {
  const { t } = useTranslation()
  const { windowSize } = useWindowSize()

  const [title, setTitle] = useState('')
  const [selectedContent, setSelectedContent] = useState()
  const [previousContent, setPreviousContent] = useState()

  const contentRefs = useRef([])

  useEffect(() => {
    if (!data) return
    setTitle(t(data.title))
  }, [t, data])

  useEffect(() => {
    if (!isValueDefined(selectedContent)) return

    if (isValueDefined(previousContent)) {
      const prev = contentRefs.current[previousContent]
      if (prev) {
        prev.classList.remove('visible')
        prev.style.display = 'none'
      }
    }

    const current = contentRefs.current[selectedContent]
    if (current) {
      current.style.display = windowSize.width >= 1050 ? 'flex' : 'block'
      setTimeout(() => current.classList.add('visible'), 50)
    }

    setPreviousContent(selectedContent)
  }, [selectedContent, windowSize.width])

  return (
    data && (
      <S.ContentSectionContainer
        id={`content-section-${index}`}
        color={data.color}
      >
        {data.decoration?.map((decor, i) => (
          <Decoration key={i} data={decor} />
        ))}
        <h2>{title}</h2>
        <ContentMenu data={data} handler={setSelectedContent} />
        {data.content.map((item, i) => (
          <ContentItem
            key={i}
            data={item}
            parentIndex={item.parentIndex}
            index={item.index}
            ref={el => (contentRefs.current[i] = el)}
          />
        ))}
      </S.ContentSectionContainer>
    )
  )
}

export default ContentSection
